import Tooltip from '@carvana/showroom-tooltip';
import InfoStandardSmall from '~/icons/InfoStandardSmall';

type OwnProps = {
  apr: string;
  maxTerm: number;
};

const MinDownTooltip = ({ apr, maxTerm }: OwnProps) => (
  <Tooltip
    content={
      <p>
        Minimum cash down is based on a {maxTerm} month loan at {apr}% APR.
        Actual APR and minimum cash down may vary based on vehicle selection and
        loan length.
      </p>
    }
    title={null}
    direction="bottom-end"
    display={{
      contentOffsetX: 17
    }}
  >
    <InfoStandardSmall className="h-[12px] w-[12px]" />
  </Tooltip>
);

export default MinDownTooltip;
